/**
 * APIから取得したdataを保存する
 */

import * as constants from '@/mixin/constants'

const state = {
  score: [],
  progress: [],
  // 学習済グループ:keyはmodeGroup
  learnedGroup: {},
  pathstepLen: [],
  pathstepChallenge: []
}

const getters = {
  score(state) {
    return state.score
  },
  progress(state) {
    return state.progress
  },
  studyState(state) {
    return state.studyState
  },
  pathstepLen(state) {
    return state.pathstepLen
  },
  pathstepChallenge(state) {
    return state.pathstepChallenge
  },
  /**
   * 指定したparamsのスコアを取得
   * params = {levelNo, unitNo, lessonIndex, pathIndex, pathstepIndex}
   */
  filterScore: (state) => (params) => {
    return filterScore(state.score, params.levelNo, params.unitNo, params.lessonIndex, params.pathIndex, params.pathstepIndex)
  },
  /**
   * 指定したparamsの進捗を取得
   * params = {levelNo, unitNo, lessonIndex, pathIndex}
   */
  filterProgress: (state) => (params) => {
    return filterProgress(state.progress, params.levelNo, params.unitNo, params.lessonIndex, params.pathIndex)
  },
  /**
   * 指定したlevelNoの進捗を取得
   */
  filterProgressByLevelNo: (state) => (levelNo) => {
    return filterProgressByLevelNo(state.progress, levelNo)
  },
  /**
   * 指定したlessonIndexの進捗を取得
   */
  filterProgressByLessonIndex: (state) => (params) => {
    return filterProgressByLessonIndex(state.progress, params.levelNo, params.unitNo, params.lessonIndex)
  },
  learnedGroup: (state) => (key) => {
    // keyValue接頭辞削除
    key = key.replace(constants.DATA_LEARNED_GROUP, '')
    if (state.learnedGroup[key]) {
      return state.learnedGroup[key]
    } else {
      return false
    }
  },
  /**
   * 指定したpathstep indexのchallengeを取得
   */
  filterPathStepChallenge: (state) => (params) => {
    return filterPathStepChallenge(state.pathstepChallenge, params.levelNo, params.unitNo, params.lessonIndex, params.pathIndex, params.pathstepIndex)
  }
}

const actions = {
  setScore({commit}, data) {
    commit('setScore', data)
  },
  setProgress({commit}, progress) {
    commit('setProgress', progress)
  },
  /**
   * 進捗データを更新
   * params = {levelNo, unitNo, lessonIndex, pathIndex, pathstepIndex}
   */
  updateProgress({commit}, params) {
    commit('updateProgress', params)
  },
  setLearnedGroup({commit}, params) {
    commit('setLearnedGroup', params)
  },
  setPathstepLen({commit}, data) {
    commit('setPathstepLen', data)
  },
  setPathstepChallenge({commit}, data) {
    commit('setPathstepChallenge', data)
  }
}

const mutations = {
  setScore(state, data) {
    state.score = data
  },
  setProgress(state, progress) {
    state.progress = progress
  },
  updateProgress(state, params) {
    var keyBase = constants.DATA_PROGRESS + params.levelNo + '-' + params.unitNo　+ '-' + params.lessonIndex　+ '-' + params.pathIndex

    // 対象のものを取得
    for(var i=0; i < state.progress.length; i++) {
      var key = Object.keys(state.progress[i])
      if(key[0] === keyBase) {
        // 削除
        state.progress.splice(i, 1)
      }
    }

    // 先頭に追加
    var val = '{"' + keyBase + '":"' + params.pathstepIndex + '"}'
    state.progress.unshift(JSON.parse(val))
  },
  setLearnedGroup(state, params) {
    // keyValue接頭辞削除
    var key = params.key.replace(constants.DATA_LEARNED_GROUP, '')
    state.learnedGroup[key] = params.val
  },
  setPathstepLen(state, data) {
    state.pathstepLen = data
  },
  setPathstepChallenge(state, data) {
    state.pathstepChallenge = data
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}

/**
 * スコア情報を取得
 */
function filterScore(score, levelNo, unitNo, lessonIndex, pathIndex, pathstepIndex) {
  var res = []

  if(score.length == 0) {
    return res
  }

  res = score.filter(function(element, index, array) {
    var split = splitScore(element)
    if(split.length == 6) {
      if(split[0] == levelNo) {
        if(split[1] == unitNo) {
          if(split[2] == lessonIndex) {
            if(split[3] == pathIndex) {
              if(split[4] == pathstepIndex) {
                return true
              }
            }
          }
        }
      }
    }
  })

  return res
}

/**
 * スコア情報を分割する
 * 配列0番: levelNo
 * 配列1番: unitNo
 * 配列2番: lesson index
 * 配列3番: path index
 * 配列4番: pathStep index
 * 配列5番: "ok" or "ng" or "skip"
 */
function splitScore(score) {
  var res = []

  var key = Object.keys(score)
  var split = key[0].split('-')
  if(split.length != 8) {
    return res
  }

  res.push(Number(split[2]), Number(split[3]), Number(split[4]), Number(split[5]), Number(split[6]), split[7])
  return res
}

/**
 * 進捗情報を取得
 */
function filterProgress(progress, levelNo, unitNo, lessonIndex, pathIndex) {
  if(progress.length == 0) {
    return -1
  }

  var keyBase = constants.DATA_PROGRESS + levelNo + '-' + unitNo　+ '-' + lessonIndex　+ '-' + pathIndex

  // 対象のものを取得
  for(var i=0; i < progress.length; i++) {
    var key = Object.keys(progress[i])
    if(key[0] === keyBase) {
      // 取得
      var json = JSON.parse(JSON.stringify(progress[i]))
      return Number(json[key])
    }
  }

  return -1
}

/**
 * levelNoの進捗データを取得
 */
function filterProgressByLevelNo(progress, levelNo) {
  if(progress.length == 0) {
    return null
  }

  var keyBase = constants.DATA_PROGRESS + levelNo

  // 対象のものを取得
  for(var i=0; i < progress.length; i++) {
    var key = Object.keys(progress[i])
    var flag = key[0].startsWith(keyBase)
    if(flag) {
      return progress[i]
    }
  }
  return null
}

/**
 * lesson進捗情報を取得
 */
function filterProgressByLessonIndex(progress, levelNo, unitNo, lessonIndex) {
  if(progress.length == 0) {
    return null
  }

  var keyBase = constants.DATA_PROGRESS + levelNo + '-' + unitNo　+ '-' + lessonIndex

  // 対象のものを取得
  for(var i=0; i < progress.length; i++) {
    var key = Object.keys(progress[i])
    var flag = key[0].startsWith(keyBase)
    if(flag) {
      return progress[i]
    }
  }
  return null
}

/**
 * challenge情報を取得
 */
 function filterPathStepChallenge(challenge, levelNo, unitNo, lessonIndex, pathIndex, pathstepIndex) {
   if(challenge.length == 0) {
     return 0
   }

   var keyBase = constants.DATA_PATHSTEP_CHALLENGE + levelNo + '-' + unitNo　+ '-' + lessonIndex　+ '-' + pathIndex + '-' + pathstepIndex

   // 対象のものを取得
   for(var i=0; i < challenge.length; i++) {
     var key = Object.keys(challenge[i])
     if(key[0] === keyBase) {
       // 取得
       var json = JSON.parse(JSON.stringify(challenge[i]))
       return Number(json[key])
     }
   }

   return 0
}



// WEBPACK FOOTER //
// ./src/store/apiValue.js